// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"224ca08f","453":"ed27f987","732":"4a1bb9a8","977":"b146a515"}[chunkId] + ".chunk.js";
};